(window["webpackJsonp_N_E"] = window["webpackJsonp_N_E"] || []).push([[204],{

/***/ "m1uF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _components_lines_product_accommodations_line_ProductAccommodationsLine__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("j6YP");

/* harmony default export */ __webpack_exports__["default"] = (_components_lines_product_accommodations_line_ProductAccommodationsLine__WEBPACK_IMPORTED_MODULE_0__[/* ProductAccommodationsLine */ "a"]);

/***/ })

}]);